import React from 'react';
import { Link } from "react-router-dom";
import styled from 'styled-components';


export const StyledLink = styled(({ ...props }) => <Link {...props} />)`
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
`